<template
  ><div style="padding-top:-2px;margin-top:-2px;">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <s-select-generic
      autocomplete
      class="text"
      itemtext="ArtDescription"
      itemvalue="ArtID"
      :disabled="disabled"
      id="ArtID"
      :value="value"
      :return-object="returnObject"
      @input="input($event)"
      :config="config"
      :full="false"
      :text="text"
      :clearable="clearable"
      :noDefault="noDefault"
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sGenericService from "@/services/Logistics/ArticlesService";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    areID: {
      type: Number,
      default: 0,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },    
    full: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
      areID(){
this.config.params.AreID=this.areID;
      },
    value(value) {
      this.item = value;
    },
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    },
  },
  
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
  }),

  created() {
    this.config = {
      url: _sGenericService.getArticlesURL(),
      title: this.label,
      params: {search: "", requestID: this.$fun.getUserID() },
    };
  },
};
</script>
